import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from '../CommonController/common-api-service';
import { governmentServerApiServer } from '../CommonController/governmentServer-api-service';
import { UserManagementApiService } from '../CommonController/userManagement-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';
import { MatIcon } from '@angular/material/icon';
import {
  MatFormField,
  MatLabel,
  MatError,
  MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { environment } from 'src/environments/environment';
import { FirmwareMasterApiServer } from '../CommonController/firmware-master-service';
@Component({
  selector: 'app-govt-servers-add-page',
  templateUrl: './govt-servers-add-page.component.html',
  styleUrls: ['./govt-servers-add-page.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    CommonSearchComponent,
    DatePipe,
  ],
})
export class GovtServersAddPageComponent implements OnInit {
  // Firmware Search Filter Pagination settings
  pageSize = 100;
  currentPage = 0;
  searchText = '';
  openCPUSearchText = '';
  firmwareMasterListSearchText = '';
  firmwareStatusFilter = [
    { key: 'Approved', value: 'Approved' },
    { key: 'Deleted or Rejected', value: 'Deleted or Rejected' },
  ];

  // Firmware arrays
  firmwareFormType = 'Add';
  today: Date = new Date();
  displayedItems = []; // List of items displayed on the current currentPage
  totalItems = 0; // Total number of items (for pagination purposes)
  totalPages = 0; // Total number of items (for pagination purposes)

  displayedA2TItems = []; // List of items displayed on the current currentPage for LCT-A4G
  totalA2TItems = 0; // Total number of items (for pagination purposes) for LCT-A4G

  // Forms
  addUpdateGovernmentServerStateForm: FormGroup;
  addUpdateGovernmentServerFirmwareForm: FormGroup;
  firmwareSearchForm: FormGroup;
  a2tFirmwareSearchForm: FormGroup;
  selectedFile: File | null = null;
  stateServerId = '';
  firmwareDisplayIsList = true;
  QAMangerList = [];
  softwareMangerList = [];
  qaView = false;
  managerView = false;

  // Permissions and logged In user details
  userPermissions = [];
  permissionList = [];
  loggedInUserId = '';
  userRole = '';
  currentFirmwareTypeFilter = '';

  firmwareTypeList = [
    { key: 'D', value: 'Device' },
    { key: 'OC', value: 'Open CPU' },
  ];

  projectName = environment.projectName;
  addFirmwareType = '';

  constructor(
    public firmwareMasterApiServer: FirmwareMasterApiServer,
    public userManagementApiService: UserManagementApiService,
    public governmentServerApiServer: governmentServerApiServer,
    public commonApiService: CommonApiService,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.stateServerId = this.route.snapshot.paramMap.get('stateServerId');
    this.checkPermission();
    this.setAddUpdateGovernmentServerStateForm();
    // this.setAddUpdateGovernmentServerFirmwareForm('');
    if (this.stateServerId !== null) {
      this.fetchDataById(this.stateServerId);
      this.fetchFirmwareList();
      if (this.projectName === 'LCT-A4G') {
        this.fetchOpenCPUFirmwareList();
      }
    }
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    if (this.stateServerId !== null) {
      this.userPermissions.forEach((element) => {
        if (element.pageName === 'Government Servers') {
          if (element.update === false) {
            this.navigateBack();
          }
        }
      });
    } else {
      this.userPermissions.forEach((element) => {
        if (element.pageName === 'Government Servers') {
          if (element.create === false) {
            this.navigateBack();
          }
        }
      });
    }
    this.userRole = sessionStorage.getItem('userRole');
    if (
      this.userRole === 'QA Manager' ||
      this.userRole === 'Software Manager'
    ) {
      const exists = this.firmwareStatusFilter.some(
        (item) => item.key === 'Under Approval'
      );
      if (!exists) {
        this.firmwareStatusFilter.push({
          key: 'Under Approval',
          value: 'Under Approval',
        });
      }
    }
  }

  setAddUpdateGovernmentServerStateForm() {
    // Initialize form outside of condition to avoid mapping issues
    this.addUpdateGovernmentServerStateForm = this.formBuilder.group({
      state: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
        SharedValidators.rangeLength(1, 50),
      ]),
      stateCode: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
        SharedValidators.rangeLength(1, 5),
      ]),
      govtIp1: new FormControl('', [SharedValidators.maxLengthRequired(20)]),
      port1: new FormControl('', [SharedValidators.portValidation]),
      govtIp2: new FormControl('', [SharedValidators.maxLengthRequired(20)]),
      port2: new FormControl('', [SharedValidators.portValidation]),
      stateEnable: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9*#]*$'),
      ]),
    });
    this.firmwareSearchForm = this.formBuilder.group({
      searchValue: new FormControl(''),
      firmwareStatus: new FormControl('Approved'),
    });

    this.a2tFirmwareSearchForm = this.formBuilder.group({
      searchValue: new FormControl(''),
      firmwareStatus: new FormControl('Approved'),
    });
  }

  submitGovtServers() {
    if (this.addUpdateGovernmentServerStateForm.invalid) {
      this.addUpdateGovernmentServerStateForm.get('state').markAsTouched();
      this.addUpdateGovernmentServerStateForm.get('stateCode').markAsTouched();
    } else {
      const payload = this.addUpdateGovernmentServerStateForm.value;
      payload.userId = this.loggedInUserId;
      this.spinner.show();
      this.governmentServerApiServer.addServer(payload).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
            this.navigateBack();
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.commonApiService.openSnackbar(ERROR.error.message);
          this.spinner.hide();
        },
      });
    }
  }

  updateGovtServers() {
    if (this.addUpdateGovernmentServerStateForm.invalid) {
      this.addUpdateGovernmentServerStateForm.get('state').markAsTouched();
      this.addUpdateGovernmentServerStateForm.get('stateCode').markAsTouched();
    } else {
      const payload = this.addUpdateGovernmentServerStateForm.value;
      payload.userId = this.loggedInUserId;
      payload.id = this.stateServerId;
      this.spinner.show();
      this.governmentServerApiServer.updateServer(payload).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
            // this.ngOnInit();
            this.fetchDataById(this.stateServerId);
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.commonApiService.openSnackbar(ERROR.error.message);
          this.spinner.hide();
        },
      });
    }
  }

  fetchDataById(stateServerId) {
    this.spinner.show();
    this.governmentServerApiServer
      .getGovtServerListRefId(stateServerId)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          const data = res.data;
          if (res.status) {
            this.addUpdateGovernmentServerStateForm = this.formBuilder.group({
              state: new FormControl(data.state, [
                SharedValidators.requiredAndNoEmptySpaces,
                SharedValidators.nonNumericNoSpecialChars,
                SharedValidators.rangeLength(1, 50),
              ]),
              stateCode: new FormControl(data.stateCode, [
                SharedValidators.requiredAndNoEmptySpaces,
                SharedValidators.nonNumericNoSpecialChars,
                SharedValidators.rangeLength(1, 5),
              ]),
              govtIp1: new FormControl(data.govtIp1, [
                SharedValidators.maxLengthRequired(20),
              ]),
              port1: new FormControl(data.port1, [
                SharedValidators.portValidation,
              ]),
              govtIp2: new FormControl(data.govtIp2, [
                SharedValidators.maxLengthRequired(20),
              ]),
              port2: new FormControl(data.port2, [
                SharedValidators.portValidation,
              ]),
              firmware: this.formBuilder.array([]),
              stateEnable: new FormControl(data.stateEnableOTACmd, [
                Validators.pattern('^[a-zA-Z0-9*#]*$'),
              ]),
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.message);
        },
      });
  }

  fetchFirmwareList() {
    this.spinner.show();
    this.firmwareMasterApiServer
      .getStateFirmwares(
        this.currentPage,
        this.pageSize,
        this.searchText,
        'D',
        this.loggedInUserId,
        this.stateServerId
      )
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.displayedItems = res.data;
            this.totalItems = res.totalItems;
            this.totalPages = res.totalPages;
            this.spinner.hide();
          }
        },
        error: (error: HttpErrorResponse) => {
          this.displayedItems = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.spinner.hide();
          this.commonApiService.openSnackbar(error.error.message);
        },
      });
  }

  fetchOpenCPUFirmwareList() {
    this.spinner.show();
    this.firmwareMasterApiServer
      .getStateFirmwares(
        this.currentPage,
        this.pageSize,
        this.openCPUSearchText,
        'OC',
        this.loggedInUserId,
        this.stateServerId
      )
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.displayedA2TItems = res.data;
            this.totalA2TItems = res.totalItems;
            this.totalPages = res.totalPages;
            this.spinner.hide();
          }
        },
        error: (error: HttpErrorResponse) => {
          this.displayedA2TItems = [];
          this.totalA2TItems = 0;
          this.totalPages = 0;
          this.spinner.hide();
          this.commonApiService.openSnackbar(error.error.message);
        },
      });
  }

  onSearchInputChange(event) {
    this.searchText = event;
    this.fetchFirmwareList();
  }

  onSearchOpenCPUInputChange(event) {
    this.openCPUSearchText = event;
    this.fetchOpenCPUFirmwareList();
  }

  onSearchFirmwareListInputChange(event) {
    this.firmwareMasterListSearchText = event;
    this.fetchAllFirmwareList(this.addFirmwareType);
  }

  deleteFirmwareFile(firmwareDetails, firmwareType): void {
    // Confirmation prompt
    if (
      confirm('Are you sure you want to remove this firmware from this state?')
    ) {
      this.spinner.show();
      this.governmentServerApiServer
        .deleteFirmware(firmwareDetails.id, this.stateServerId, firmwareType)
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            if (res.status) {
              this.commonApiService.openSnackbar(res.message);
              this.ngOnInit();
            } else {
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.commonApiService.openSnackbar(ERROR.error.message);
            this.spinner.hide();
          },
        });
    } else {
      this.commonApiService.openSnackbar('User cancelled the delete action');
    }
  }

  downloadFirmwareFile(fileURL): void {
    if (!fileURL) {
      this.commonApiService.openSnackbar('No URL provided for the download.');
      return;
    }

    // Validate URL format
    const isValidURL = /^https?:\/\/.+\.[a-z]{2,}(\/.+)?$/.test(fileURL);
    if (!isValidURL) {
      this.commonApiService.openSnackbar(`Invalid URL format: ${fileURL}`);
      alert('The provided URL is not valid. Please check the URL.');
      return;
    }

    // Confirmation prompt
    if (confirm('Are you sure you want to download this firmware file?')) {
      // Extract filename from the URL
      const filename = fileURL.split('/').pop() || 'firmware-file.bin';

      // Create a temporary link element to start the download
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = filename; // Set the filename for the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Cleanup after download
      this.commonApiService.openSnackbar(`Download started for ${filename}`);
    } else {
      this.commonApiService.openSnackbar('Download cancelled by the user.');
    }
  }

  file_upload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const isPakOrBin =
        file.name.endsWith('.pak') ||
        file.name.endsWith('.bin') ||
        file.name.endsWith('.tar');
      if (isPakOrBin) {
        this.selectedFile = file;
        this.addUpdateGovernmentServerFirmwareForm
          .get('fileName')
          .setValue(file.name);
      } else {
        this.addUpdateGovernmentServerFirmwareForm
          .get('fileName')
          ?.setErrors({ invalidFileType: true });
        this.commonApiService.openSnackbar(
          'Please select only a .pak or .bin or .tar file.'
        );
      }
    }
  }

  addNewFirmware(firmwareType: string) {
    this.firmwareDisplayIsList = !this.firmwareDisplayIsList;
    if (!this.firmwareDisplayIsList) {
      this.selectedFirmwareIds = [];
      this.addFirmwareType = firmwareType;
      this.firmwareFormType = 'Add';
      this.fetchAllFirmwareList(firmwareType);
    }
  }

  FirmwareMasterList = [];
  fetchAllFirmwareList(firmwareType) {
    this.spinner.show();
    this.firmwareMasterApiServer
      .getFirmwaresListNotAddedInState(
        this.currentPage,
        1000,
        this.firmwareMasterListSearchText,
        firmwareType,
        this.stateServerId
      )
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.FirmwareMasterList = res.data;
            this.totalItems = res.totalItems;
            this.totalPages = res.totalPages;
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.FirmwareMasterList = [];
            this.totalItems = 0;
            this.totalPages = 0;
            this.commonApiService.openSnackbar(res.message);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.FirmwareMasterList = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.spinner.hide();
          this.commonApiService.openSnackbar(error.error.message);
        },
      });
  }

  // Checkbox functionality for selecting multiple firmware items
  selectedFirmwareIds: Number[] = [];
  onRowCheckboxChange(event: Event, firmwareId: Number): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      if (!this.selectedFirmwareIds.includes(firmwareId)) {
        this.selectedFirmwareIds.push(firmwareId);
      }
      console.log(`Selected Firmware IDs: ${this.selectedFirmwareIds}`);
    } else {
      this.selectedFirmwareIds = this.selectedFirmwareIds.filter(
        (id) => id !== firmwareId
      );
      console.log(`Selected Firmware IDs: ${this.selectedFirmwareIds}`);
    }
  }

  // re-write Submit firmware details for adding or updating
  submitGovtServerFirmwareDetails() {
    this.spinner.show();
    const firmwareDto = {
      stateServerId: this.stateServerId,
      firmwareIds: this.selectedFirmwareIds,
      userId: this.loggedInUserId,
      firmwareType: this.addFirmwareType,
    };
    this.governmentServerApiServer.saveStateFirmware(firmwareDto).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.firmwareDisplayIsList = !this.firmwareDisplayIsList;
          this.commonApiService.openSnackbar(res.message);
          this.ngOnInit();
        } else {
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.commonApiService.openSnackbar(ERROR.error.message);
        this.spinner.hide();
      },
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
